import {
  ACHIEVEMENT_ART,
  achievementImageUrl,
} from "./nft-art.js";

const STREAK_CLAIM_MIN = 3;

/**
 * Collapse duplicate achievement types for gallery cards.
 * @param {Array<{ achievement_type: number }>} heldTypes
 */
export function collapseHeldTypes(heldTypes) {
  const map = new Map();
  for (const item of heldTypes || []) {
    const type = Number(item.achievement_type);
    const existing = map.get(type);
    if (existing) {
      existing.count += 1;
    } else {
      map.set(type, { ...item, achievement_type: type, count: 1 });
    }
  }
  return [...map.values()].sort((a, b) => a.achievement_type - b.achievement_type);
}

/**
 * Poll achievements when holdings are empty but streak stats suggest a mint may land soon.
 * @param {object | null | undefined} stats
 * @param {Array<unknown>} heldTypes
 */
export function shouldPollEmptyHoldings(stats, heldTypes) {
  if (!stats) return false;
  if (heldTypes?.length > 0) return false;
  return Boolean(stats.qualifies_streak_3 || stats.streak >= STREAK_CLAIM_MIN);
}

/**
 * @param {object | null | undefined} snapshot
 */
export function hasAgentActivity(snapshot) {
  if (!snapshot) return false;
  try {
    const deployed = BigInt(snapshot.deployed_lux || "0");
    const fees = BigInt(snapshot.fees_paid_lux || "0");
    const openMarkets = Number(snapshot.positions_summary?.open_markets || 0);
    return deployed > 0n || fees > 0n || openMarkets > 0;
  } catch {
    return false;
  }
}

/**
 * @param {ReturnType<typeof collapseHeldTypes>} collapsed
 * @param {string} [origin]
 */
export function buildHeldTypesGallery(collapsed, origin = "") {
  const grid = document.createElement("div");
  grid.className = "trader-gallery";
  if (!collapsed.length) {
    const empty = document.createElement("p");
    empty.className = "hint trader-gallery-empty";
    empty.textContent = "No achievement NFTs yet";
    grid.append(empty);
    return grid;
  }
  for (const item of collapsed) {
    const card = document.createElement("article");
    card.className = "trader-gallery-card dt-card";
    const art = ACHIEVEMENT_ART[item.achievement_type];
    const img = document.createElement("img");
    img.className = "trader-gallery-art";
    img.alt = art?.name || `Achievement ${item.achievement_type}`;
    img.loading = "lazy";
    if (art) {
      img.src = achievementImageUrl(item.achievement_type, origin);
    }
    const title = document.createElement("h3");
    title.className = "trader-gallery-title";
    title.textContent = art?.name || `Type ${item.achievement_type}`;
    card.append(img, title);
    if (item.count > 1) {
      const badge = document.createElement("span");
      badge.className = "dt-pill";
      badge.textContent = `×${item.count}`;
      card.append(badge);
    }
    grid.append(card);
  }
  return grid;
}
